import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import '@/permission'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueCoreVideoPlayer from 'vue-core-video-player'
import { Lazyload } from 'vant'

Vue.use(Lazyload)

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true
})

Vue.use(VueCoreVideoPlayer)

Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
